/* @flow strict */

import * as React from 'react';

const Case2 = (): React.Element<'div'> => {
  return (
    <div className="sparxo-embeded-body" id='sparxo_scroll_1000'>
      <div className="sparxo-client-view">
        <div className="sparxo-embeded-tickets">
          <div className="sparxo-embeded-message">
            <i className="icon icon-sale-end" />

            <p>
              Oops! Looks like the online ticket sales for this event are over.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Case2;
